import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseRadioButtonGroup = {
  gap: css`var(--cse-radio-button-group-gap, ${csSpacing.spacing05})`,
  gapInline: css`var(--cse-radio-button-group-gap-inline, ${csSpacing.spacing08})`,
}

export const style = css`
  .cse-radio-button-group {
    display: flex;
    flex-direction: column;
    gap: ${cseRadioButtonGroup.gap};
  }

  .inline {
    flex-direction: row;
    gap: ${cseRadioButtonGroup.gapInline};
  }
`
